import { render } from "./certificateSubjects.vue?vue&type=template&id=38fcd008"
import script from "./certificateSubjects.vue?vue&type=script&lang=js"
export * from "./certificateSubjects.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__